import { generateCode } from '@apex-org/code-generator';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - v7 is not defined in the uuid package
import { v7 as uuid } from 'uuid';

import { Dispense } from '../interfaces/IDispense';
import { getCodeType } from '../utils/get-codetype';

export class CreateDispense {
  public newDispense: Dispense;

  constructor(
    scheduleId: string,
    allowAlphanumeric: boolean,
    digitLength: number,
    frictionless?: string,
    expireLoaded?: boolean,
    verify = false
  ) {
    const dispenseId = `dispense-${uuid()}`;
    const codeType = getCodeType(allowAlphanumeric);
    this.newDispense = {
      id: dispenseId,
      dispenseId: dispenseId,
      dispense: dispenseId,
      dispenseSchName: '',
      verify,
      verified: false,
      product: [''],
      schedule: scheduleId,
      createTimeDsp: new Date().getTime(),
      // will be override
      expireTime: 0,
      dispensedTimeDsp: 0,
      flowId:
        frictionless === 'frictionless'
          ? 'flow-dispense-frictionless-default'
          : 'flow-dispense-default',
      updateTimes: {},
      loadCode: generateCode(codeType, digitLength),
      undoCode: generateCode(codeType, digitLength),
      reclaimCode: generateCode(codeType, digitLength),
      reclaimedCode: generateCode(codeType, digitLength),
      verifyCode: generateCode(codeType, digitLength),
      minAge: 0,
      dispensePrice: 0,
      minTemperature: 0,
      maxTemperature: 0,
      minPenaltyFactor: 0,
      maxPenalty: '5',
    };
    if (expireLoaded) {
      delete this.newDispense.expireTime; // if expireTime not exist then backend calc expireTime using dwellTimeout
    }
  }

  getDispense(): Dispense {
    return this.newDispense;
  }
}
